import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import PhoneListingCard from 'app/components/PhoneListingCard';

const MockPhoneListing = ({ listing }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box sx={{ position: 'relative', display: 'block', width: 'fit-content' }}>
        <Box sx={{ textAlign: 'left' }}>
          <PhoneListingCard
            listing={listing}
            onDetailsClick={() => {}}
          />
        </Box>

        {/* Call Now Button */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '34px',
            left: '240px',
            transform: 'translateX(-50%)',
            zIndex: 10,
          }}
        >
          <a href="#" onClick={(e) => e.preventDefault()} style={{ textDecoration: 'none' }}>
            <div className="call-button call-now">
              <span>Call Now</span>
            </div>
          </a>
        </Box>

        {/* Price Per Minute (Below Call Button) */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '8px',
            left: '240px',
            transform: 'translateX(-50%)',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: 'var(--card_secondary_txt)', fontSize: '0.813em', width: '120px' }}>
            <span style={{ display: 'inline-block' }}>{`$${listing.price_per_minute}`}</span>
            <span style={{ display: 'inline-block', color: '#999' }}>&nbsp;per min.</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

MockPhoneListing.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number.isRequired,
    login: PropTypes.string.isRequired,
    full_category: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    photo_url: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    total_ratings: PropTypes.number.isRequired,
    price_per_minute: PropTypes.number.isRequired,
  }).isRequired,
};

export default MockPhoneListing;
